import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { TestTs } from 'locales';

interface Iprops {
  messages: TestTs;
}


const Test = (props: Iprops) => {
  return (
    <>
      <NavLink to="/home">홈으로</NavLink>
    </>
  )
}


export default Test;



// WEBPACK FOOTER //
// ./src/pages/test.tsx